module.exports = __webpack_public_path__ + "media/images/logo-xs-705f43fc175fbb6e7883a9afa9d07a09.png";